<template>
  <div class="register-container">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <h1  style="font-weight: bold; " v-if="title === ('Free Sign Up' || 'Sign Up')">{{title}}</h1>
          <h3 class="m-b-md" style="font-weight: bold;" v-else>{{title}}</h3>
          <h4  style="" v-if="title === '15 Days Free Trial'">Step 1/2</h4>
        </div>
        <div class="row" v-if="buttonLogin === true">
          <div class="col-xs-12 text-right">
            <span style="font-size: 14px; font-weight: 500;"> Already have an account?<router-link :to="{name: 'Login'}" class="text-info font-bold"> Sign In</router-link></span>
          </div>
        </div>
        <div class="hpanel">
          <div class="panel-body">
            <form v-on:submit="register" action="#" method="post" id="registerForm">
              <div class="row" style="">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="form-group col-md-6 col-xs-12" v-bind:class="{'has-error' : errorFirstName , 'has-success' : errorFirstName === false}">
                      <label for="firstName" class="required">{{ $t('signUp.form_firstName.label') }}</label>
                      <input type="" v-model="firstName" id="firstName" class="form-control" name="firstName" v-bind:placeholder="$t('signUp.form_firstName.place_holder')" required>
                      <span v-if="errorFirstName " class="help-block text-danger">{{ errorFirstName }}</span>
                    </div>
                    <div class="form-group col-md-6 col-xs-12" v-bind:class="{'has-error' : errorLastName , 'has-success' : errorLastName === false}">
                      <label for="LastName" class="required">{{ $t('signUp.form_lastName.label') }}</label>
                      <input type="" v-model="lastName" id="lastName" class="form-control" name="lastName" v-bind:placeholder="$t('signUp.form_lastName.place_holder')" required>
                      <span v-if="errorLastName" class="help-block text-danger">{{ errorLastName }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="row">
                    <div class="form-group col-xs-12" v-bind:class="{'has-error' : errorEmail, 'has-success' : errorEmail === false}" >
                      <label for="email" class="required">{{ $t('signUp.form_email.label') }}</label>
                      <input type="email" v-model="email" id="email" class="form-control" name="email" v-bind:placeholder="$t('signUp.form_email.place_holder')" required>
                      <span v-if="errorEmail" class="help-block text-danger">{{ errorEmail }}</span>
                    </div>
                    <div class="form-group col-xs-12" v-bind:class="{'has-error' : errorPassword, 'has-success' : errorPassword === false}">
                      <label for="password" class="required">{{ $t('signUp.form_password.label') }}</label>
                      <input type="password" v-model="password" id="password" class="form-control" name="password" v-bind:placeholder="$t('signUp.form_password.place_holder')" required>
                      <span v-if="errorPassword" class="help-block text-danger">{{ errorPassword }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="row">
                    <div class="form-group col-lg-12 hide">
                      <label for="companyName">{{ $t('signUp.form_company.label') }}</label>
                      <input type="" v-model="companyName" id="companyName" class="form-control" name="companyName" v-bind:placeholder="$t('signUp.form_company.place_holder')">
                    </div>
                    <div class="form-group col-xs-12">
                      <label for="phone" >{{ $t('signUp.form_phone.label') }}
                        <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="$t('signUp.form_phone.help_block')"></i></label>
                      <input type="phone" v-model="phone" id="phone" class="form-control" name="phone" v-bind:placeholder="$t('signUp.form_phone.place_holder')">
                      <span v-if="errorPhone" class="help-block text-danger">{{ errorPhone }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12" style="margin-top: 5px">
                  <div class="checkbox checkbox-info" >
                    <input type="checkbox" style="position: absolute; opacity: 0;" id="termsOfUse" name="termsOfUse" v-model="termsOfUse" required>
                    <label for="termsOfUse" v-html="$t('signUp.form_checkbox_termsOfUse.label')"> <span style="color: red">*</span></label>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="checkbox checkbox-info">
                    <input type="checkbox" style="position: absolute; opacity: 0;" id="news" name="news" v-model="news">
                    <label for="news" > {{ $t('signUp.form_checkbox_news.label') }}</label>
                  </div>
                </div>
              </div>
              <div class="row text-center" style="margin-top: 10px;">
                <div class="col-xs-12 col-sm-3"></div>
                <vue-ladda type="submit" :loading="submitRegister.loading" class="btn btn btn-info col-sm-6 col-xs-12" :data-style="submitRegister.dataStyle">{{ $t('signUp.form.register') }}</vue-ladda>
              </div>
              <div class="row hide">
                <div class="col-xs-6" style="margin-top: 10px"></div>
                <div class="col-xs-6" style="text-align: right;margin-top: 10px">
                  <span style="font-style: italic;font-size: 12px">(<span style="color: red">*</span>) required fields</span>
                </div>
              </div>
              <div class="dividerWrapper m-b-md"><div class="dividerContent">or connect with</div></div>
              <div class="row text-center">
                <div class="m-b-sm col-sm-2 col-xs-12">
                </div>
                <div class="m-b-sm col-sm-2 col-xs-12">
                  <router-link class="btn btn-info btn-lg btn-outline" title="Linkedin" :to="{name: 'SsoConnection', params: {provider: 'linkedin'}}"><i class="fab fa-linkedin-in"></i></router-link>
                </div>
                <div class="m-b-sm col-sm-2 col-xs-12">
                  <router-link class="btn btn-info btn-lg btn-outline" title="Google" :to="{name: 'SsoConnection', params: {provider: 'google'}}"><i class="fab fa-google"></i></router-link>
                </div>
                <div class="m-b-sm col-sm-2 col-xs-12">
                  <router-link class="btn btn-info btn-lg btn-outline" title="Facebook" :to="{name: 'SsoConnection', params: {provider: 'facebook'}}"><i class="fab fa-facebook-square text-info"></i></router-link>
                </div>
                <div class="m-b-sm col-sm-2 col-xs-12">
                  <router-link class="btn btn-info btn-lg btn-outline" title="Microsoft" :to="{name: 'SsoConnection', params: {provider: 'azure'}}"><i class="fab fa-brands fa-microsoft text-info"></i></router-link>
                </div>
                <div class="m-b-sm col-sm-2 col-xs-12">
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row hide">
      <div class="col-md-12 text-center">
        <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright Idexlab
      </div>
    </div>
  </div>

</template>

<style scoped>
  .dividerWrapper {
    width: 100%;
    height: 20px;
    border-bottom: 1px solid #eaeaea;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

  }
  .dividerContent {
    background-color: #fff;
    padding: 0 20px;
    margin-top: 1em;
  }
  #registerForm .checkbox{
    margin-bottom: 5px;
    margin-top: 5px;
  }
  #registerForm .form-control {
    height: 30px;
    background-color: #f7f9fa;
  }
  #registerForm .checkbox label {
    color: #000;
    font-weight: 400;
    font-family: system-ui;
  }
  .register-container {
    /*padding-top: 15%;*/
  }
  @media (min-width: 990px) {
    .register-container {
      width: 65%;
    }
    #registerForm .form-group label {
      margin-bottom: 2px;
    }
    #registerForm .form-group {
      margin-bottom: 10px;
    }
  }
  @media (max-width: 990px) {
    #registerForm .form-group {
      margin-bottom: 0px;
    }
    #registerForm .form-group label {
      margin-bottom: 0px;
      margin-top: 2px;
    }
  }
</style>

<script>

import VueLadda from 'vue-ladda'
import VueCookies from 'vue-cookies'

export default {
  components: {VueLadda},
  name: 'SimplifiedRegistration',
  props: {
    title: {
      required: true
    },
    buttonLogin: {
      default: true
    },
    emailPrefilled: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      firstName: typeof this.$route.params.firstName !== 'undefined' ? this.$route.params.firstName : '',
      lastName: typeof this.$route.params.lastName !== 'undefined' ? this.$route.params.lastName : '',
      rememberMe: false,
      passwordConfirm: '',
      companyName: '',
      phone: null,
      password: '',
      isSME: true,
      termsOfUse: false,
      news: false,
      ip: '',
      errorLastName: null,
      errorFirstName: null,
      errorEmail: null,
      errorPhone: null,
      errorPassword: null,
      errorTermsOfUse: null,
      submitRegister: {
        loading: false,
        dataStyle: 'zoom-in'
      },
      year: new Date().getFullYear()
    }
  },
  methods: {
    register: function (event) {
      this.submitRegister.loading = true
      if (this.lastName === '' || this.firstName === '' || this.email === '' ||
          this.password === '' || this.termsOfUse === false) {
        this.errorFirstName = !this.firstName
        this.errorLastName = !this.lastName
        this.errorEmail = !this.email
        this.errorPassword = !this.password
        this.errorPasswordConfirm = true
        this.errorTermsOfUse = !this.termsOfUse

        if (this.errorPasswordConfirm === true) {
          this.passwordConfirm = ''
        }
        this.submitRegister.loading = false
      } else {
        this.errorLastName = false
        this.errorFirstName = false
        this.errorEmail = false
        this.errorPassword = false
        this.errorPasswordConfirm = false
        this.errorTermsOfUse = false
        this.errorPhone = false

        this.$auth.register({
          data: {
            email: this.email,
            lastName: this.lastName,
            firstName: this.firstName,
            password: this.password,
            company: this.companyName,
            goal: this.goal,
            phone: this.phone,
            newsletter: this.news,
            isSME: true,
            plan: localStorage.getItem('register_plan') === 'expert' ? 'expert' : 'basic'
          },
          autoLogin: false,
          redirect: null,
          success: (response) => {
            this.$auth.token(null, response.data.access_token)

            this.$notify({
              type: 'success',
              title: 'Your account has been created successfully!',
              placement: 'bottom-right'
            })

            this.$auth.watch.data = response.data.data // user object
            VueCookies.set('rememberMe', true)
            this.$auth.watch.authenticated = true
            this.$salesMachine.clearUser()
            this.$salesMachine.signUp()
            localStorage.setItem('is_already_connect', 'true')

            this.redirectAfterRegister()
          },
          error: (res) => {
            if (res.response.status === 400) {
              let errors = res.response.data.errors
              switch (res.response.data.code) {
                case 1:
                  this.errorEmail = errors['email'][0]
                  break
                case 2:
                  this.errorLastName = errors['lastName'][0]
                  break
                case 3:
                  this.errorFirstName = errors['firstName'][0]
                  break
                case 4:
                  this.errorPassword = errors['password'][0]
                  break
                case 5:
                  this.errorPhone = errors['phone'][0]
                  break
              }
            }
            this.submitRegister.loading = false
          }
        })
      }
      event.preventDefault()
    },
    redirectAfterRegister: function () {
      let goTo
      let redirect = localStorage.getItem('redirect')

      if (redirect !== null && redirect !== '/') {
        localStorage.removeItem('redirect')
        if (this.$user.isBasic() && this.goal === 'topics') {
          goTo = {name: 'Plans'}
          localStorage.setItem('trial', true)
          localStorage.setItem('register_plan', 'silver')
          localStorage.setItem('register_interval', 'm')
          localStorage.setItem('register_redirect', redirect)
        } else {
          goTo = {path: redirect}
        }
      } else {
        let plan = localStorage.getItem('register_plan')
        if (plan && plan !== 'basic' && plan !== 'expert' && this.$user.isSme()) {
          goTo = {name: 'Plans'}
        } else if (this.$user.isSme() && this.$user.isBasic()) {
          goTo = this.$user.isExpert() && !this.$user.hasExpertProfile() ? {name: 'Profile'} : {name: 'Start'}
        } else {
          goTo = {name: 'Dashboard', params: {}}
        }
      }
      setTimeout(() => {
        this.$router.push(goTo)
      }, 500)
    },
    setGoal: function () {
      this.goal = (this.$route.query.goal) ? decodeURI(this.$route.query.goal) : this.goal

      let redirect = localStorage.getItem('redirect')
      if (redirect !== null) {
        let goal = redirect.match(new RegExp('goal=([^&]+)', 'g'))
        if (goal !== null) {
          goal = goal[0].split('=')
          this.goal = goal[1]
          localStorage.setItem('goal', this.goal)
        }
      }
    }
  },
  mounted () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      container: 'body'
    })
    setTimeout(() => {
      if (document.getElementById('launcher')) {
        document.getElementById('launcher').style.display = 'none'
      }
    }, 6000)
  },
  beforeMount () {
    if (this.emailPrefilled !== null) {
      this.email = this.emailPrefilled
    } else {
      this.email = (!this.email && this.$route.query.email) ? decodeURI(this.$route.query.email) : this.email
    }

    this.firstName = (this.$route.query.firstName) ? decodeURI(this.$route.query.firstName) : this.firstName
    this.lastName = (this.$route.query.lastName) ? decodeURI(this.$route.query.lastName) : this.lastName
    this.companyName = (this.$route.query.company) ? decodeURI(this.$route.query.company) : this.companyName

    this.setGoal()
    let trial = this.$route.query.trial

    if (typeof trial === 'undefined') {
      localStorage.removeItem('trial')
    } else {
      localStorage.setItem('trial', trial)
    }
  },
  beforeDestroy () {
    this.$salesMachine.clearUser()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/register/SimplifiedRegistration.vue